var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRegistration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 18,
    viewBox: "0 0 21.5 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-220.5 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-people",
    "data-name": "Icon material-people",
    d: "M10.5,15.214a3.857,3.857,0,1,0-3.857-3.857A3.841,3.841,0,0,0,10.5,15.214Zm0,2.571c-3,0-9,1.5-9,4.5V25.5h18V22.286C19.5,19.29,13.5,17.786,10.5,17.786Z",
    transform: "translate(222.5 7.5)",
    fill: "#f9a603"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_573",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 573",
    transform: "translate(-19.5 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_952",
    "data-name": "\\u9577\\u65B9\\u5F62 952",
    width: 7,
    height: 1.5,
    transform: "translate(240 19.5)",
    fill: "#f9a603"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_953",
    "data-name": "\\u9577\\u65B9\\u5F62 953",
    width: 7,
    height: 1.5,
    transform: "translate(244.25 16.75) rotate(90)",
    fill: "#f9a603"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRegistration);
export default __webpack_public_path__ + "static/media/icon-registration.e9d760aff7e5b1352fe920c82ca693e0.svg";
export { ForwardRef as ReactComponent };